import { useState } from 'react';

import { AgentScoreCardMetrics, ChannelScoreCardMetrics } from '../types/AgentScoreCardMetrics';

interface UseMetricsPaginationProps {
  filteredMetrics: ChannelScoreCardMetrics[] | AgentScoreCardMetrics[];
}
const rowsPerPage = 5;

export const useMetricsPagination = ({ filteredMetrics }: UseMetricsPaginationProps) => {
  const maxPages = Math.ceil(filteredMetrics.length / rowsPerPage);
  const [page, setPage] = useState(1);
  const onNext = () => {
    if (page === maxPages) return;
    setPage(page + 1);
  };
  const onPrev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };
  const disablePrev = page === 1;
  const disableNext = page === maxPages;

  return { page, setPage, maxPages, rowsPerPage, onNext, onPrev, disableNext, disablePrev };
};
